var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b4fd0167-2631-4523-b550-d957e9373231",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.99 20.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b0cf1c75-d216-40e0-9157-e7af73f6574b{fill:#574de6;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b0cf1c75-d216-40e0-9157-e7af73f6574b",
    d: "M12,21c-.34,0-.46-.1-.6-.49-.59-1.69-1.17-3.37-1.75-5.06-.33-.93-.65-1.86-1-2.8a.52.52,0,0,0-.36-.37L.7,9.6.42,9.5C.19,9.4,0,9.28,0,9a.6.6,0,0,1,.39-.63l2.32-1L19.86.15l.19-.08a.67.67,0,0,1,.79.13.62.62,0,0,1,.06.74q-1,2.54-2.12,5.08l-6,14.42C12.56,20.87,12.42,21,12,21Zm.09-2.49h.07l6.26-15a.35.35,0,0,0-.21.11c-2.72,2.72-5.45,5.45-8.18,8.16a.34.34,0,0,0-.09.42c.35,1,.69,2,1,3S11.75,17.4,12.12,18.49Zm5.36-15.9,0-.06-15,6.36.2.08c2.07.68,4.14,1.36,6.21,2.06.21.07.28,0,.39-.16L17.28,2.8Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.7ec86356a3f76d552f50991c97176ff5.svg";
export { ForwardRef as ReactComponent };